import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=d9fc19a0&lang=less"
script.__scopeId = "data-v-d9fc19a0"

export default script